import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export const constantRouterMap = [
  {
    path: "/",
    name: "Index",
    component: (resolve) => require(["@/views/Index"], resolve),
  },
  // {
  //   path: "/t",
  //   name: "test",
  //   component: (resolve) => require(["@/views/test"], resolve),
  // }
];

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
});
